import { MobileMenuContext } from "@context/mobileMenuContext";
import { AnimatePresence } from "framer-motion";
import { useContext } from "react";

import { cn } from "@/lib/utils";
import MarketSelectorList from "@features/market/components/MarketSelectorList";
import MobileMenuDirectionAnimation from "./MobileMenuDirectionAnimation";
import MobileMenuLink from "./MobileMenuLink";

export default function MobileMenuLinks() {
  const { navigationTree } = useContext(MobileMenuContext);

  const currentNavigation = navigationTree?.at(-1);
  if (!currentNavigation) return null;

  if (currentNavigation.type === "Market") {
    return (
      <div>
        <AnimatePresence initial={false} mode="popLayout">
          <MobileMenuDirectionAnimation>
            <MarketSelectorList />
          </MobileMenuDirectionAnimation>
        </AnimatePresence>
      </div>
    );
  }

  if (currentNavigation.type === "Brand") {
    return (
      <div className="flex flex-col">
        <AnimatePresence initial={false} mode="popLayout">
          {currentNavigation.children?.map((link) =>
            link?.children?.slice(0, 12).map((sublink, subLinkIndex) => (
              <MobileMenuDirectionAnimation
                key={"sublink" + sublink?.slug + subLinkIndex}
              >
                <MobileMenuLink link={sublink ?? undefined} />
              </MobileMenuDirectionAnimation>
            )),
          )}
        </AnimatePresence>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col",
        currentNavigation.children?.length && "py-4",
      )}
    >
      <AnimatePresence initial={false} mode="popLayout">
        {currentNavigation.children?.map((link, linkIndex) => (
          <MobileMenuDirectionAnimation
            key={"default" + link?.slug + linkIndex}
          >
            <MobileMenuLink link={link} />
          </MobileMenuDirectionAnimation>
        ))}
      </AnimatePresence>
    </div>
  );
}
